import { useState } from "react";
import { dummyDays } from "../dummyData";
import { useDispatch, useSelector } from "react-redux";
import { uploadSingleFileImage } from "../apis/UploadImgApis";
import { AddDealsApis, EditDealsApis } from "../apis/DealsApis";
import { toast } from "react-toastify";
import { setAllDealsData } from "../redux/action";
import moment from "moment";
export const useDealsHooks = (setisOpen) => {
  //all redux
  const deals_Redux = useSelector((s) => s?.allDealsData);
  const place_item_details = useSelector((s) => s?.placeDetails ?? {});
  const [editDealsModal, setEditDealsModal] = useState(false);
  const [editDealItemId, setEditItemId] = useState("");
  const dispatch = useDispatch();
  //all local states
  const [selectedDays, setSelectedDays] = useState([]);
  const [dealData, setDealData] = useState({
    title: "",
    itemName: "",
    description: "",
    startDate: "",
    endDate: "",
    from: "",
    to: "",
    days: dummyDays,
    selectedDays: selectedDays,
  });

  //all functions

  const handleDaysSelect = (value, at) => {
    let array = [...dealData?.days];
    array[at].checked = value;
    let filterSelectedArray = array?.filter((i) => i?.checked);
    setSelectedDays(filterSelectedArray);
    setDealData((prev) => ({ ...prev, days: array }));
  };

  const handleClearData = () => {
    setDealData({
      days: dummyDays,
      description: "",
      endDate: "",
      from: "",
      to: "",
      itemName: "",
      startDate: "",
      title: "",
      image: null,
    });
  };

  const onPressDoneBtn = () => {
    let imgPayload = {
      file: dealData?.image,
    };

    uploadSingleFileImage(imgPayload).then((e) => {
      if (e?.success) {
        let payload = {
          place: place_item_details?._id,
          itemName: dealData?.itemName,
          description: dealData?.description,
          price: dealData?.price,
          startDate: dealData?.startDate,
          endDate: dealData?.endDate,
          timeSlot: {
            from: dealData?.from,
            to: dealData?.to,
          },
          picture: e?.data,
          days: selectedDays?.map((e) => e?.day),
          title: dealData?.title,
        };
        console.log({ payload });
        AddDealsApis(payload)
          .then((e) => {
            console.log("response is===>", e?.data?.data?.deal);
            if (e?.success) {
              toast?.success("deals added successfully");
              setisOpen(false);
              dispatch(setAllDealsData([...deals_Redux, e?.data?.data?.deal]));
            }
          })
          .catch((err) => {
            console.log("api called cerror", err);
          });
      } else {
        toast?.error(e?.data?.message);
      }
    });
  };

  //edit deals functions

  const onPressDealsItemEditBtn = (item) => {
    setEditItemId(item?._id);
    console.log("iddd=>", item?._id);
    setDealData({
      title: item?.title,
      itemName: item?.itemName,
      price: item?.price,
      description: item?.description,
      from: item?.timeSlot?.from,
      to: item?.timeSlot?.to,
      days: dummyDays,
      selectedDays: item?.days,
      startDate: moment(item?.startDate).format("YYYY-MM-DD"),
      endDate: moment(item?.endDate).format("YYYY-MM-DD"),
      image: item?.picture,
    });
    setEditDealsModal(true);
  };

  const onPressEditBtn = async () => {
    const dealImage = dealData?.image;
    const isImageUrl =
      typeof dealImage === "string" && dealImage?.startsWith("http");

    const buildPayload = (imageUrl) => ({
      place: place_item_details?._id,
      itemName: dealData?.itemName,
      description: dealData?.description,
      price: dealData?.price,
      startDate: dealData?.startDate,
      endDate: dealData?.endDate,
      timeSlot: {
        from: dealData?.from,
        to: dealData?.to,
      },
      picture: imageUrl,
      days: selectedDays?.map((e) => e?.day),
      title: dealData?.title,
    });

    try {
      let finalImage = dealImage;

      if (!isImageUrl) {
        const uploadResp = await uploadSingleFileImage({ file: dealImage });
        if (!uploadResp?.success) throw new Error("Image upload failed");
        finalImage = uploadResp?.data;
      }

      const payload = buildPayload(finalImage);

      const response = await EditDealsApis(payload, editDealItemId);
      console.log("response is===>", response?.data?.data?.deal);

      if (response?.success) {
        toast?.success("Deals edited successfully");
        setEditDealsModal(false);
        const updatedDeal = response?.data?.data?.deal;

        const updatedDealsList = deals_Redux?.map((deal) =>
          deal?._id === updatedDeal?._id ? updatedDeal : deal
        );

        dispatch(setAllDealsData(updatedDealsList));
      }
    } catch (err) {
      console.error("Error editing deal:", err);
    }
  };

  return {
    //all local states
    dealData,
    setDealData,
    selectedDays,
    setSelectedDays,
    //all functions

    handleClearData,
    onPressDoneBtn,
    handleDaysSelect,

    //edit deals states & functions
    //all local states

    editDealsModal,
    setEditDealsModal,
    //all functions
    onPressDealsItemEditBtn,
    onPressEditBtn,
  };
};
